import useTranslation from 'next-translate/useTranslation';
import { PageBreadcrumbsResponse } from 'src/pages/api/page-breadcrumbs';
import { useSiteContext } from 'src/store';
import useSWR from 'swr';

const fetcher = (url: string): Promise<any> =>
  fetch(url).then((res) => res.json());

const useBreadcrumbs = (pageId: string) => {
  const { t } = useTranslation();
  const { tenantId, packageId } = useSiteContext();

  const { data, error, isLoading } = useSWR<PageBreadcrumbsResponse>(
    `/api/page-breadcrumbs?tenantId=${tenantId}&packageId=${packageId}&pageId=${pageId}`,
    fetcher
  );

  const isHomePage = (fullUrlSlug: string) => {
    return fullUrlSlug === '/';
  };

  const transformedBreadcrumbs = data?.breadcrumbs?.map((crumb, index) => ({
    text: isHomePage(crumb.fullUrlSlug)
      ? t('breadcrumbs.home')
      : crumb.displayValue,
    href: crumb.fullUrlSlug,
    disabled: index === (data?.breadcrumbs?.length ?? 0) - 1,
  }));

  return {
    breadcrumbs: transformedBreadcrumbs,
    isLoading,
    isError: error,
  };
};

export default useBreadcrumbs;
